import { env } from '@/utils/env';
import type { StaticImport } from 'next/dist/shared/lib/get-img-props';

/** 图片展示与服务端资源提示共用同一套 CDN、语言和格式规则。 */
export function resolveImageSrc(src: string | StaticImport, locale: string) {
  if (!src) return null;

  let formatSrc = src;
  if (
    typeof src === 'string' &&
    !src.startsWith('http') &&
    !src.startsWith('//') &&
    !src.startsWith('blob:')
  ) {
    if (src.startsWith('/images/') && env.NEXT_PUBLIC_S3_FULL_URL.startsWith('/')) {
      formatSrc = src;
    } else {
      formatSrc = src.startsWith('/')
        ? `${env.NEXT_PUBLIC_S3_FULL_URL}${src}`
        : `${env.NEXT_PUBLIC_S3_FULL_URL}/${src}`;
    }
    if (typeof formatSrc === 'string' && formatSrc.includes('{locale}')) {
      formatSrc = formatSrc.replaceAll('{locale}', `.${locale}`);
    }
  }

  if (
    typeof formatSrc === 'string' &&
    !formatSrc.startsWith('blob:') &&
    !formatSrc.match(
      /jpg|jpeg|png|gif|webp|svg|ico|bmp|tiff|tif|heic|heif|avif|jfif|pjpeg|pjp|apng/,
    )
  ) {
    return null;
  }

  return formatSrc;
}
